<script lang="ts" setup>
import Swal from "sweetalert2";
const airlinesStore = useAirlinesStore();
const localStorage = useLocalStorageStore();
const userStrore = useUserStore();
const config = useRuntimeConfig();
const kotaAsal = ref({
  id: "CGK",
  name: "SOEKARNO HATTA",
  city: "Jakarta - Cengkareng",
  country: "Indonesia",
  timezone: null,
  gmt: null
});
const kotaTujuan = ref({
  id: "SIN",
  name: "CHANGI",
  city: "Singapore",
  country: "Singapore",
  domestic: 1,
  international: 1,
  timezone: null,
  gmt: null
});
const trip  = ref();
const airports = ref<any>({});
const interairports = ref<any>({})
const airlines = ref<any>({})
const maskapai = ref("ALL_INTL")
const cabin = ref("economy");
const tgl_dep = ref();
const tgl_ret = ref();
const adt = ref(1);
const inf = ref(0);
const chd = ref(0);
const loading = ref(false);
const searchOrg = ref();
const searchDes = ref()
const orgInput = ref();
const desInput = ref();

const getAirports = async()  => {
  try{
    const response: any = localStorage.getDomAirports() ;
    airports.value = response

    const interRes: any = localStorage.getInternationalAirport();
    interairports.value = interRes
  }catch(error){
    console.error(error)
  }
}

const getAirlines =  () => {
  try{
    const response: any = localStorage.getAirlinesCode();
    airlines.value = response
  }catch(error){
    console.error(error)
  }
}

const setCabin = (value: string) => {
  cabin.value = value;
};

const closeDropdown = () => {
  const dropdownElement = document.getElementById('dropdownPenumpang');
  const dropdownInstance = bootstrap.Dropdown.getInstance(dropdownElement);
  dropdownInstance.hide();
};

const focusSearch = (type) => {
  nextTick(() => {
    let element = null;
    if (type === 'org') {
      element = orgInput.value;
    } else if (type === 'des') {
      element = desInput.value;
    }
    
    if (element) {
      setTimeout(() => {
        element.focus();
      }, 100); // Adjust the delay if necessary
    } else {
      console.error(`Element with ref ${type} not found`);
    }
  });
};

const selectOrg = (airport: any) => {
  kotaAsal.value = airport
}

const selectDes = (airport: any) => {
  kotaTujuan.value = airport
}


watch(searchOrg, () => {
  if (!searchOrg.value) {
    airports.value = localStorage.getInternationalAirport() ;
  } else {

    airports.value = airports.value.filter((airport: { name: string; id: string; city: string; }) =>
      airport.name.toLowerCase().includes(searchOrg.value.toLowerCase()) ||
      airport.id.toLowerCase().includes(searchOrg.value.toLowerCase()) ||
      airport.city.toLowerCase().includes(searchOrg.value.toLowerCase())
    );
  }
})


watch(searchDes, () => {
  if (!searchDes.value) {
    interairports.value = localStorage.getInternationalAirport() ;
  } else {

    interairports.value = interairports.value.filter((airport: { name: string; id: string; city: string; }) =>
      airport.name.toLowerCase().includes(searchDes.value.toLowerCase()) ||
      airport.id.toLowerCase().includes(searchDes.value.toLowerCase()) ||
      airport.city.toLowerCase().includes(searchDes.value.toLowerCase())
    );
  }
})

onMounted(() => {
  getAirports();
  getAirlines();
})
const selectTrip = (type: any) => {
  trip.value = type
}

const selectCabin = (type: any) => {
  cabin.value = type
}

const selectMaskapai = (type: any) => {
  maskapai.value = type
}

const schedule = async() => {
  try{
    loading.value = true;
    const response: any = await airlinesStore.getSchedule({
      class:cabin.value, //economy or business
      international:true,
      ac: maskapai.value,
      org: kotaAsal.value.id,
      des:kotaTujuan.value.id,
      trip: trip.value,
      tgl_dep: tgl_dep.value,
      tgl_ret: tgl_ret.value,
      adt: adt.value,
      chd: chd.value,
      inf: inf.value,
    });

    if(response.status.code == 200){
      if(response.details?.journeys[0]?.flights.length > 0){
        navigateTo('/airlines/schedules')
      }else{
        Swal.fire({
          title: 'Warning',
          html: 'shedules not found',
          icon: 'warning',
        });
      }
    }else{
      Swal.fire({
          title: 'kesalahan Validasi',
          html: `${response.status.message}`,
          icon: 'warning',
        });
    }
  }catch(error){
    console.error(error)
  }finally{
    loading.value = false;
  }
}

const swapValues = () => {
  const temp = { ...kotaAsal.value };
  kotaAsal.value = { ...kotaTujuan.value };
  kotaTujuan.value = { ...temp };
};
</script>

<template>
    <Customloading v-if="loading" />
    <div>
      <div>
        <div class="form mx-2">
          <div class="my-3">
            <!-- <InputNumber /> -->
            <div class="row">
              <div class="col-12 col-lg-3 col-md-3 mb-3">
                <button class="form-select border-0 rounded text-start" type="button" id="trip" data-bs-toggle="dropdown" aria-expanded="false">{{ trip === 'O' ? 'Satu Arah' : 'Pulang Pergi' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="trip" style="cursor: pointer">
                  <li @click="selectTrip('O')">Satu Arah</li>
                  <li  @click="selectTrip('R')">Pulang Pergi</li>
                </ul>
              </div>

              <div class="col-12 col-lg-3 col-md-3 mb-3">
                <button class="form-select border-0 rounded text-start" type="button" id="trip" data-bs-toggle="dropdown" aria-expanded="false">{{ `${adt} Dewasa` }} {{ chd > 0 ? `, ${chd} Anak` : '' }} {{ inf > 0 ? `, ${inf} Bayi` : '' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="trip" @pointerdown.stop @click.stop>
                  <div class="ms-2 my-3">
                    <label class="py-3 fw-bold">Tambah Jumlah Penumpang</label>
                    <div class="row mt-3">
                      <div class="col-12 col-lg-6 col-md-6">
                        <label class="pb-3">Penumpang Dewasa</label>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <InputNumber v-model="adt" :min="1" :max="7" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-lg-6 col-md-6">
                        <label class="pb-3">Penumpang Anak</label>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <InputNumber v-model="chd" :min="0" :max="7" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-lg-6 col-md-6">
                        <label class="pb-3">Penumpang Bayi</label>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <InputNumber v-model="inf" :min="0" :max="7" />
                      </div>
                    </div>
                  </div>
                </ul>
              </div>

              <div class="col-12 col-lg-3 col-md-3 mb-3">
                <button class="form-select border-0 rounded text-start" type="button" id="cabin" data-bs-toggle="dropdown" aria-expanded="false">{{ cabin === 'economy' ? 'Ekonomi' : 'Bisnis' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="cabin" style="cursor: pointer;">
                  <li @click="selectCabin('economy')">Ekonomi</li>
                  <li  @click="selectCabin('business')">Bisnis</li>
                </ul>
              </div>

              <div class="col-12 col-lg-3 col-md-3 mb-3">
                <button class="form-select border-0 rounded text-start" type="button" id="maskapai" data-bs-toggle="dropdown" aria-expanded="false">{{ maskapai === 'ALL_INTL' ? 'All maskapai' : maskapai === 'QZ' ? 'Air Asia' :  maskapai === 'QG' ? 'Citilink' : maskapai === 'GA' ? 'Garuda Indonesia' : maskapai === 'JT' ? 'Lion Air' : maskapai === 'IP' ? 'Pelita Air' : maskapai === 'SJ' ? 'Sriwijaya' : maskapai === 'MV' ? 'Trans Nusa' : maskapai === 'IL' ? 'Trigana Air' : maskapai  }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="maskapai" style="cursor: pointer;">
                  <ul @click="selectMaskapai('ALL_INTL')">All Maskapai</ul>
                  <ul @click="selectMaskapai('QZ')">Air Asia</ul> 
                  <ul @click="selectMaskapai('QG')">Citilink</ul> 
                  <ul @click="selectMaskapai('GA')">Garuda Indonesia</ul> 
                  <ul @click="selectMaskapai('JT')">Lion Air</ul> 
                  <ul @click="selectMaskapai('IP')">Pelita Air</ul> 
                  <ul @click="selectMaskapai('SJ')">Sriwijaya</ul> 
                  <ul @click="selectMaskapai('MV')">Trans Nusa</ul> 
                  <ul @click="selectMaskapai('IL')">Trigana Air</ul>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 col-md-6">
              <div class="row">
                <div class="col-12 col-lg-5 col-md-5">
                  <div class="input-container">
                    <label for="dropdownKotaAsal">Berangkat dari</label>
                    <div class="dropdown input-group mb-3">
                      <button
                        class="form-control rounded text-start"
                        type="button"
                        id="dropdownKotaAsal"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        @click="focusSearch('org')"
                      >
                        {{ `${kotaAsal.name} (${kotaAsal.id})` }}
                      </button>
                      <ul class="dropdown-menu pt-0 w-100" aria-labelledby="dropdownKotaAsal">
                        <div class="bg-white sticky-top py-1">
                          <input
                            type="text"
                            class="form-control border border-1 rounded shadow-none m-2"
                            v-model="searchOrg"
                            ref="orgInput"
                            placeholder="Search..."
                          />
                        </div>
                        <div class="scrollable-menu ms-2">
                          <li
                            v-for="airport in airports"
                            :key="airport.id"
                            style="cursor:pointer;"
                            @click="selectOrg(airport)"
                          >
                            <label>{{ airport.name }}</label>
                            <span class="badge bg-primary">{{ airport.id }}</span>
                            <div style="display: block">
                              <small class="text-default"
                                ><em>{{ `${airport.city},${airport.country}` }}</em></small
                              >
                            </div>
                          </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-5 d-none d-lg-block d-md-block mt-3">
                  <div class="swap-button">
                    <button class="btn btn-primary" @click="swapValues">
                      <i class="fa-solid fa-repeat"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-lg-5 col-md-5">
                  <div class="input-container">
                    <label for="dropdownKotaTujuan">Pergi ke</label>
                    <div class="dropdown input-group mb-3">
                      <button
                        class="form-select rounded text-start"
                        type="button"
                        id="dropdownKotaTujuan"
                        data-bs-toggle="dropdown"
                        @click="focusSearch('des')"
                        aria-expanded="false"
                      >
                        {{ `${kotaTujuan.name} (${kotaTujuan.id}` }}
                      </button>
                      <ul class="dropdown-menu pt-0 w-100" aria-labelledby="dropdownKotaTujuan">
                        <div class="bg-white sticky-top py-1">
                          <input
                            type="text"
                            class="form-control border border-1 rounded shadow-none m-2"
                            v-model="searchDes"
                            placeholder="Search..."
                            ref="desInput"
                          />
                        </div>
                        <div class="scrollable-menu ms-2">
                          <li
                            v-for="airport in airports"
                            :key="airport.id"
                            style="cursor:pointer;"
                            @click="selectDes(airport)"
                          >
                            <label>{{ airport.name }}</label>
                            <span class="badge bg-primary">{{ airport.id }}</span>
                            <div style="display: block">
                              <small class="text-default"
                                ><em>{{ `${airport.city},${airport.country}` }}</em></small
                              >
                            </div>
                          </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-md-4">
              <div class="row">
                <div class="col">
                  <label for="">Tanggal Pergi</label>
                  <dateInput v-model="tgl_dep" />
                </div>
                <div class="col" v-if="trip === 'R'">
                  <label for="">Tanggal Pulang</label>
                  <dateInput v-model="tgl_ret" :minDate="tgl_dep" />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-2 col-md-2 mt-3">
              <button
                type="button"
                class="btn fw-semibold text-white mt-2"
                @click="schedule"
                style="width: 100%; background-color: #fb8b34"
              >
                Cari
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>
.dropdown button:hover {
  cursor: pointer;
}

.scrollable-menu {
  max-height: 200px;
  overflow: auto;
}

.scrollable-menu li {
  display: block;
  position: relative;
  padding: 8px;
  width: 100%;
}

.scrollable-menu li .badge {
  position: absolute;
  right: 8px;
  top: 33%;
  transform: translateY(-50%);
}

.scrollable-menu li:hover {
  background-color: #f8f9fa;
}
</style>
